// i18n.js - Plain JavaScript file without ERB
require("i18n-js");

import I18n from "i18n-js";

// Default to English, then try to get from meta tag
let locale = "en";
try {
  const localeTag = document.querySelector("meta[name='locale']");
  if (localeTag) {
    locale = localeTag.getAttribute("content");
  }
} catch (e) {
  console.error("Error getting locale:", e);
}

// Import all locales statically
const enLocales = require("../../locales/en.json");
const deLocales = require("../../locales/de.json");
const itLocales = require("../../locales/it.json");
const frLocales = require("../../locales/fr.json");
const nlLocales = require("../../locales/nl.json");

// Select the correct locale
let locales;
switch (locale) {
  case "de":
    locales = deLocales;
    break;
  case "it":
    locales = itLocales;
    break;
  case "fr":
    locales = frLocales;
    break;
  case "nl":
    locales = nlLocales;
    break;
  default:
    locales = enLocales;
}

I18n.translations = locales;
I18n.defaultLocale = "en";
I18n.locale = locale;

window.I18n = I18n;
